export function BoneyardListFallback({
  columns = 1,
  count,
  gap = 12,
  height,
}: {
  columns?: number;
  count: number;
  gap?: number;
  height: number;
}) {
  return (
    <div
      aria-hidden="true"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap,
        width: '100%',
      }}
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          style={{
            height,
            borderRadius: 12,
            // Same palette configureBoneyard registers (#e5e7eb / #374151); the
            // hardcoded light value made every bone a white block in dark mode.
            background: 'var(--color-border)',
          }}
        />
      ))}
    </div>
  );
}
